<template>
    <header>
        <div class="contain">
            <div class="contain_left">
                <div class="logo">
                    <!-- 根据域名判断链接地址 -->
                    <a :href="logoLink"><img src="https://cdn.kuailework.com/images/officialWebsite/index/head_img_logo.png" alt=""></a>
                </div>
                <span @click="redirect(1)" class="tab">首页</span>
                <span @click="changeStatus" class="tab">发布职位</span>
                <span @click="redirect(6)" class="tab">我的发布</span>
                <!--<span class="tab" v-if="!isHr">-->
                <!--<el-input placeholder="搜索心仪的职位" style="width:18rem" v-model="content" @change="getJob(content)"><i slot="prefix" class="el-input__icon el-icon-search"></i>-->
                <!--</el-input>-->
                <!--</span>-->
            </div>
            <div class="contain_right">
                <!--<span @click="redirect(3)" class="tab" v-show="!isShow">-->
                <!--<i class="el-icon-message" style="margin-right:0.3rem" @click="redirect(5)">-->
                <!--</i>消息中心<span class="icon" v-show="count > 0" ref="icon">{{ count }}</span>-->
                <!--</span>-->
                <span class="tab" v-if="account">{{account}}</span>
                <span class="tab" v-if="account">账户余额：{{balance}}，<span class="toRecharge" @click="toRecharge">去充值</span></span>
                <span class="tab" v-if="account" @click="logout()">退出登录</span>
                <span class="tab" v-if="!account" @click="redirect(4)">请登录</span>
                <span class="tab" v-if="!account" @click="redirect(7)">注册</span>
                <section class="right">
                    <div class="phone">
                        <img style="margin-right: 4px;" src="https://cdn.kuailework.com/images/officialWebsite/index/icon_phone.png" alt="">
                        <div class="vz-font">400-607-6006</div>
                    </div>
                </section>
            </div>
        </div>
        <el-dialog width="900" :append-to-body="true" title="发布职位" :visible.sync="publishvisible">
            <el-form :model="publishInfo" :rules="publishRules" size="small" ref='publishInfo' label-width="80px">
                <el-form-item label="职位名称" prop="name" class="jobinput">
                    <el-input class="require" v-model="publishInfo.name"></el-input>
                </el-form-item>
                <el-form-item label="工作经验" prop="experience" class="jobinput">
                    <el-input class="require" v-model="publishInfo.experience"></el-input>
                </el-form-item>
                <el-form-item label="学历要求" prop="education" class="jobinput">
                    <!--<el-input class="require" v-model="publishInfo.education"></el-input>-->
                    <el-select v-model="publishInfo.education">
                        <el-option label="初中及以下" value="1"></el-option>
                        <el-option label="高中" value="2"></el-option>
                        <el-option label="本科" value="3"></el-option>
                        <el-option label="专科" value="4"></el-option>
                        <el-option label="硕士及以上" value="5"></el-option>
                        <el-option label="不限" value="9"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="联系电话" prop="link" class="jobinput">
                    <el-input class="require" v-model="publishInfo.link"></el-input>
                </el-form-item>
                <el-form-item label="工作地点" prop="address" class="jobinput">
                    <el-input class="require" v-model="publishInfo.address"></el-input>
                </el-form-item>
                <el-form-item label="薪资范围" prop="address" class="jobinput">
                    <el-input class="salary" style="width: 200px" v-model="publishInfo.address"></el-input>
                    <span style="margin-left: 10px;">元</span>
                </el-form-item>
                <el-form-item label="岗位标签" prop="label" class="jobinput">
                    <el-input class="require" style="width: 120px" v-model="publishInfo.label"></el-input>
                    <el-button style="margin-left: 10px;" @click="addLabel">确定</el-button>
                    <el-tag
                            @close="closeTag(idx)"
                            style="margin-left: 10px;"
                            v-for="(tag,idx) in publishInfo.labelList"
                            :key="tag"
                            closable>
                        {{tag}}
                    </el-tag>
                </el-form-item>
                <el-form-item label="职位介绍" prop="content" class="jobinput">
                    <el-input type="textarea" rows="10" class="require"
                              v-model="publishInfo.content"></el-input>
                </el-form-item>

                <!--<el-form-item label="技术栈" prop="skillList">-->
                <!--<el-button @click="addskill()" class="addbtn">添加</el-button>-->
                <!--<div v-for="(item, key) in publishInfo.skillList" :key="key">-->
                <!--<input placeholder="技术" class="requireinput" v-model="item.name"/>-->
                <!--<select class="requireselect" v-model="item.weight">-->
                <!--<option label="了解" value=1></option>-->
                <!--<option label="熟悉" value=2></option>-->
                <!--<option label="掌握" value=3></option>-->
                <!--<option label="精通" value=4></option>-->
                <!--</select>-->
                <!--<i class="el-icon-error delete" @click="deleteItem(key)"></i>-->
                <!--</div>-->
                <!--</el-form-item>-->
                <el-form-item>
                    <el-button @click="addjob('publishInfo')">确定</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <el-dialog title="充值" :append-to-body="true" width="500px" :visible.sync="rechargeDialog">
            <div class="recharge_dialog">
                <p style="line-height: 40px;">请选择充值金额：</p>
                <div class="money_card">
                    <el-button class="money_btn" @click="toPay(10)">10元(10积分)</el-button>
                    <el-button class="money_btn" @click="toPay(20)">20元(20积分)</el-button>
                    <el-button class="money_btn" @click="toPay(50)">50元(50积分)</el-button>
                </div>
                <!--<div style="display: flex;margin-top: 10px;">-->
                    <!--<el-input style="width: 300px;" type="text" placeholder="自定义金额"></el-input>-->
                    <!--<el-button type="primary" style="margin-left: 14px;">确定</el-button>-->
                <!--</div>-->
                <p style="line-height: 40px;" v-if="payNum > 0">请扫描下方二维码：</p>
                <div class="qrcode_box" v-if="payNum > 0">
                    <img v-if="payNum == 10" src="@/assets/10yuan.png"/>
                    <img v-if="payNum == 20" src="@/assets/20yuan.png"/>
                    <img v-if="payNum == 50" src="@/assets/50yuan.png"/>
                </div>
            </div>
        </el-dialog>
    </header>
</template>
<style>
    .contain_left{
        display: flex;
        align-items: center;
    }
    .contain_right{
        display: flex;
        align-items: center;
    }
    .contain_right .phone{
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        color: #1478FF;
        width: 143px;
        height: 32px;
        border-radius: 4px;
        border: 1px solid #1478FF;
    }
    .contain_right .vz-font{
        font-weight: bold;
    }
    .contain_left .logo{
        height: 60px;
        display: flex;
        align-items: center;
        width: 101px;
        height: 36px;
    }
    .contain_left .logo img{
        display: block;
        width: 100%;
        height: 100%;
    }
    .recharge_dialog{
        text-align: left;
    }
    .recharge_dialog .money_card{
        display: flex;
        flex-wrap: wrap;
    }
    .recharge_dialog .money_card .money_btn{
        width: 120px;
        margin-right: 10px;
        margin-top: 10px;
        margin-left: 0px;
    }
    .qrcode_box img{
        width: 160px;
        height: 160px;
        display: block;
        margin: 0 auto;
    }
    .jobinput {
        text-align: left;
    }

    html * {
        padding: 0;
        margin: 0;
    }

    * {
        box-sizing: border-box;
    }

    header {
        width: 100%;
        height: 60px;
        background: #fff;
        box-shadow: 0px 4px 8px 0px rgba(220,220,220,0.4);
    }

    .contain {
        display: flex;
        justify-content: space-between;
        width: 1200px;
        margin: auto;
        line-height: 60px;
        font-weight: 500;

    }

    .contain .tab {
        color: #333;
        font-size: 16px;
        /*margin: 10px;*/
        /*padding: 6px;*/
        border-radius: 4px;
        cursor: pointer;
        margin: 0 16px;
    }

    .icon {
        position: relative;
        background: red;
        font-size: 10px;
        border-radius: 50%;
        left: 0;
        top: -8px;
        padding: 0 5px;
        color: #fff;
    }

    .requireinput {
        width: 35%;
        height: 40px;
        border-radius: 4px;
        border: 1px solid #dcdfe6;
        outline: 0;
        background: #fff;
        padding: 0 15px;
        margin: auto 11.2px 14px auto;
    }

    .requireselect {
        width: 35%;
        height: 40px;
        border-radius: 4px;
        border: 1px solid #dcdfe6;
        outline: 0;
        background: #fff;
        padding: 0 15px;
        margin: auto 11.2px 14px auto;
    }

    .require {
        width: 80%;
    }

    .addbtn {
        position: relative;
        top: 40px;
        left: 280px;
    }

    .delete {
        color: #dcdfe6;
        position: relative;
        left: -10px;
    }

    .delete:hover {
        color: red;
    }
    .toRecharge:hover{
        color: red;
    }
</style>
<script>
    import getData from "@/api/getData";

    export default {
        data() {
            return {
                payNum: 0,
                rechargeDialog: false,
                account: '',
                balance: 0,
                index: 0,
                count: 0,
                amount: 0,
                websocket: null,
                publishInfo: {
                    name: '',
                    experience: '',
                    education: '',
                    content: '',
                    label: '',
                    labelList: [],
                    link: '',
                    address: '',
                    salary: ''
                },
                publishvisible: false,
                isHr: false,
                content: '',
                companyList: [],
                msg: '',
                isShow: true,
                publishRules: {
                    name: [{required: true, message: '该项不能为空', trigger: 'blur'}],
                    experience: [{required: true, message: '该项不能为空', trigger: 'blur'}],
                    education: [{required: true, message: '该项不能为空', trigger: 'blur'}],
                    content: [{required: true, message: '该项不能为空', trigger: 'blur'}],
                    address: [{required: true, message: '该项不能为空', trigger: 'blur'}],
                    link: [{required: true, message: '该项不能为空', trigger: 'blur'}],
                },
                login: true
            }
        },
        created() {

        },
        watch: {
            amount() {
                location.reload()
            }
        },
        mounted() {
            if (localStorage.getItem('recruit_account')) {
                this.account = localStorage.getItem('recruit_account')
                this.getUserDetail()
            }else{
                this.account = ''
            }
        },
        methods: {
            toPay(num){
                this.payNum = num
            },
            getUserDetail(){
                getData.get('https://nocoapi.kuailework.com/api/v2/tables/mzxtcps7s396av0/records',{
                    where: '(account,eq,' + this.account + ')'
                }).then(res =>{
                    if(res && res.data.list && res.data.list.length > 0){
                        let row =  res.data.list[0]
                        this.balance = row.balance
                        localStorage.setItem('phone', row.phone)
                        localStorage.setItem('balance', row.balance)
                    }
                })
            },
            addLabel(){
                this.publishInfo.labelList.push(this.publishInfo.label)
                this.publishInfo.label = ''
            },
            closeTag(idx){
                this.publishInfo.labelList.splice(idx, 1)
            },
            openWS() {
                console.log('建立连接')
            },
            receiveWSMessage(e) {
                console.log('接收消息' + e.data)
                this.count = parseInt(e.data)
            },
            closeWS() {
                console.log('关闭连接')
            },
            toRecharge(){
                this.payNum = 0
                this.rechargeDialog = true
            },
            redirect(num) {
                if (num === 1) {
                    this.$router.push({name: 'index'})
                } else if (num === 2) {
                    this.$router.push({name: 'userInfo'})
                } else if (num === 3) {
                    this.$router.push({name: 'infoCenter'})
                } else if (num === 4) {
                    this.$router.push({name: 'login'})
                } else if (num === 5) {
                    this.$router.push({name: 'infoCenter'})
                } else if (num === 6) {
                    if(!this.account){
                        this.$confirm('当前未登录，请先登录', '提示', {
                            confirmButtonText: '去登录',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            this.$router.push({name: 'login'})
                        }).catch(() => {

                        });
                    }else{
                        this.$router.push({name: 'hrView'})
                    }
                }else if (num === 7) {
                    this.$router.push({name: 'register'})
                }
            },
            toregister() {
                this.$router.push({name: 'register'})
            },
            getJob(value) {
                if (value !== null) {
                    localStorage.setItem('content', value)
                }
                this.$router.push({name: 'search', params: {count: 1}})
            },
            logout() {
                localStorage.removeItem('recruit_account')
                localStorage.removeItem('phone')
                localStorage.removeItem('balance')
                window.location.reload()
                // this.$router.push({name: 'login'})
            },
            addjob(formName) {
                let account = localStorage.getItem('recruit_account')
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        getData.post('https://nocoapi.kuailework.com/api/v2/tables/mp4l49rzxw9n1zo/records',{
                            account: account,
                            name: this.publishInfo.name,
                            experience: this.publishInfo.experience,
                            education: this.publishInfo.education,
                            content: this.publishInfo.content,
                            address: this.publishInfo.address,
                            link: this.publishInfo.link,
                            salary: this.publishInfo.salary,
                            label: this.publishInfo.labelList.join(",")
                        }).then(res =>{
                            if(res && res.data.id >= 0){
                                this.publishvisible = false
                                this.$refs[formName].resetFields()
                                location.reload()
                                this.$message({
                                    message: "发布成功",
                                    type: "success"
                                });
                            }
                        })
                    }
                })
            },
            deleteItem(key) {
                this.publishInfo.skillList.splice(key, 1)
            },
            addskill() {
                let newskills = {
                    weight: 0,
                    name: ''
                }
                this.publishInfo.skillList.push(newskills)
            },
            changeStatus() {
                console.log(this.account)
                if(!this.account){
                    this.$confirm('当前未登录，请先登录', '提示', {
                        confirmButtonText: '去登录',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.$router.push({name: 'login'})
                    }).catch(() => {

                    });
                }
                // else if(this.balance < 2){
                //     this.$confirm('发布职位需要2点积分，当前账户余额不足，无法发布！', '提示', {
                //         confirmButtonText: '去充值',
                //         cancelButtonText: '取消',
                //         type: 'warning'
                //     }).then(() => {
                //         this.rechargeDialog = true
                //     }).catch(() => {
                //
                //     });
                // }
                else{
                    this.publishvisible = true
                }

            }
        },
        computed: {
            /**
             * 根据当前域名返回对应的 logo 链接地址
             * @returns {string} logo 链接地址
             */
            logoLink() {
                const hostname = window.location.hostname;
                if (hostname.includes('soucaigroup')) {
                    return 'https://www.soucaigroup.com';
                }
                // kuailework 域名或其他域名都使用默认链接
                return '/';
            }
        }
    }
</script>
